import * as Types from './ColorPalette.d';
import ColorPalette, { ColorPalette as CP } from './ColorPalette';
import { ColorPaletteStyled, Color } from './ColorPalette.styled';

export type ColorPaletteProps = Types.ColorPaletteProps;
export type ColorProps = Types.ColorProps;
export { CP as ColorPalette, ColorPaletteStyled, Color };
export default ColorPalette;
